module.exports = __webpack_public_path__ + "static/kdb-banner-3@2x-7448c6c2f0b883223678076d8d4fa766.png";